import { ReduceStore } from 'flux/utils';
import AppDispatcher from '../AppDispatcher';
import { Styling } from './StylingStore';
import Constants from '../Constants';

class LoginStylingStore extends ReduceStore {
  getInitialState() {
    return new Styling();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.Admin.LOGIN_STYLING_REQUESTED:
        return null;
      case Constants.Admin.LOGIN_STYLING_LOADED:
        return new Styling(action.styling);
      case Constants.Admin.LOGIN_STYLING_NOT_FOUND:
        return new Styling();
      default:
        return state;
    }
  }

  isReady() {
    return this.getState() !== null;
  }
}

const instance = new LoginStylingStore(AppDispatcher);
export default instance;
